import React from 'react';
import PropTypes from 'prop-types';

import { faListCheck } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'shared/empty_state';

const PlannerEmptyState = ({ children, message }) => {
  return (
    <EmptyState
      header="No tasks or critical dates"
      bodyText={message}
      icon={faListCheck}
    >
      {children}
    </EmptyState>
  );
};

PlannerEmptyState.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string,
};

export default PlannerEmptyState;
